import React from 'react';
import {
  FullUploadComponent,
  VStack,
  LinkUploadFile,
  FileWithExternalLink,
} from '@wegroup/design-system';

interface Props {
  onAdd: (files: File[]) => void;
  onAddLink: (file: LinkUploadFile) => Promise<void>;
  onRemove: (index: number) => void;
  onRemoveLink: (index: number) => void;
  files: File[];
  linkFiles: FileWithExternalLink[];
  isLoading?: boolean;
  isLoadingLinkFiles?: boolean;
}

const InsuranceFormDocumentUpload: React.FC<Props> = ({
  onAdd,
  onAddLink,
  onRemove,
  onRemoveLink,
  files,
  linkFiles,
  isLoading,
  isLoadingLinkFiles,
}) => {
  return (
    <VStack spacing={3} alignItems="stretch">
      <FullUploadComponent
        uploadZoneProps={{
          multiple: true,
          accept: ['.jpg', '.jpeg', '.png', '.pdf'],
          onFilesAccepted: onAdd,
          isLoading,
        }}
        uploadListProps={{
          files,
          onRemove,
        }}
        linkUploadProps={{
          onLinkAccepted: onAddLink,
          isLoading: isLoadingLinkFiles,
        }}
        linkUploadListProps={{
          onRemove: onRemoveLink,
          files: linkFiles,
        }}
        withLink
      />
    </VStack>
  );
};

export default InsuranceFormDocumentUpload;
